var monriScript;
export default {
  methods: {
    loadMonriScript(success = () => {}) {
      // console.log(publicKey)
      if (!monriScript) {
        monriScript = window.document.createElement("script");
        monriScript.src = "https://ipgtest.monri.com/dist/components.js";
        if (this.paymentMode && this.paymentMode.liveFlag) {
          monriScript.src = "https://ipg.monri.com/dist/components.js";
        }
        monriScript.onload = () => {
          success && success();
        };
        var head =
          window.document.head ||
          window.document.getElementsByTagName("head")[0] ||
          window.document.documentElement;
        head.insertBefore(monriScript, head.firstChild);
      } else {
        success && success();
      }
    }
  }
};
